import { render, staticRenderFns } from "./UpdatesLog.vue?vue&type=template&id=cda42598"
import script from "./UpdatesLog.vue?vue&type=script&lang=js"
export * from "./UpdatesLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports